/* src/app/views/smart-filters/components/smart-filter-card-row/smart-filter-card-row.component.scss */
.bs-light {
  font-family: poppins, sans-serif;
  font-weight: 300;
  font-style: normal;
}
.bs-italic {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: italic;
}
.bs-regular {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: normal;
}
.bs-medium {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: normal;
}
.bs-medium-italic {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: italic;
}
.bs-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: italic;
}
.bs-semi-bold {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: normal;
}
.bs-semi-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: italic;
}
.bs-bold {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: normal;
}
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.smart-filter-card-deck {
  display: block;
  flex-direction: row;
}
.smart-filter-card-deck .card {
  margin-bottom: 15px;
}
.parent-row {
  position: relative;
  height: 5.5rem;
  z-index: 98;
  display: flex;
}
.gradient-row {
  position: relative;
  display: flex;
  overflow: hidden;
}
.gradient-row::before {
  content: "";
  position: absolute;
  right: 0;
  background:
    linear-gradient(
      to left,
      white,
      rgba(255, 255, 255, 0.001));
  height: 3.5rem;
  width: 2.1rem;
  margin-right: -0.1rem;
  z-index: 100;
}
.gradient-row::after {
  content: "";
  position: absolute;
  top: 0;
  background:
    linear-gradient(
      to right,
      white,
      rgba(255, 255, 255, 0.001));
  height: 3.5rem;
  z-index: 100;
  width: 0.85rem;
  margin-left: -0.1rem;
}
.category-row {
  position: relative;
  display: flex;
  overflow-x: auto;
  height: 5rem;
  gap: 1.5rem;
  background: white;
}
.applied-filter-row {
  display: flex;
  min-height: 3rem;
  flex-flow: wrap;
  margin-top: 0.8rem;
  gap: 1rem 1rem;
}
.add-filter-button {
  height: 3.5rem;
  width: 6rem;
  font-size: 0.85rem;
  flex-shrink: 0;
}
.plus-icon {
  height: 1rem;
  width: 1rem;
  margin-left: 0.5rem;
}
:host ::ng-deep .mat-expansion-panel-body {
  padding: 0;
}
.title {
  font-size: 0.875rem;
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: normal;
}
hr {
  margin-bottom: auto;
}
/*# sourceMappingURL=smart-filter-card-row.component.css.map */
